/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */
import { FEATURES } from 'services/globals';

export const displayIIFooter = () => IIComponentsFooterEnabled();

export const activitySummaryCommentaryEnabled = () =>
  FEATURES.AAM_UI_FEATURE_AS_COMMENTARY === true;

export const portfolioGrowthAccountsWithShareClassMessageEnabled = () =>
  FEATURES.AAM_UI_PORTFOLIO_GROWTH_CHART_SHARE_CLASS === true;
export const portfolioGrowthCommentaryEnabled = () =>
  FEATURES.AAM_UI_FEATURE_PGT_COMMENTARY === true;

export const personalRateOfReturnCommentaryEnabled = () =>
  FEATURES.AAM_UI_FEATURE_PRR_COMMENTARY === true;

export const requestCacheEnabled = () => FEATURES.AAM_UI_ENABLE_CACHE === true;

export const messageCenterPageEnabled = () =>
  FEATURES.AAM_UI_INTERNAL_MESSAGE_CENTER_PAGE === true;

export const newMessageCenterCountEnabled = () =>
  FEATURES.AAM_UI_NEW_MESSAGE_CENTER_COUNT === true;

export const newUsernameLinkEnabled = () =>
  FEATURES.AAM_UI_NEW_USERNAME_LINK === true;

export const newPasswordLinkEnabled = () =>
  FEATURES.AAM_UI_NEW_PASSWORD_LINK === true;

export const contactMethodMaintenanceModalEnabled = () =>
  FEATURES.AAM_UI_INTERNAL_CMM === true;

export const intradayRefreshEnabled = () =>
  FEATURES.AAM_UI_INTRADAY_REFRESH === true;

export const businessEventDispatchEnabled = () =>
  FEATURES.AAM_UI_BUSINESS_EVENT_DISPATCH === true;

export const internalEnhancedBenefitsPageEnabled = () =>
  FEATURES.AAM_UI_ENHANCED_BENEFITS_PAGE === true;

export const internalPersonalBenefitsPageEnabled = () =>
  FEATURES.AAM_UI_PERSONAL_BENEFITS_PAGE === true;

export const internalCoreBenefitsPageEnabled = () =>
  FEATURES.AAM_UI_CORE_BENEFITS_PAGE === true;

export const multiFactorSecurityLinkEnabled = () =>
  FEATURES.AAM_UI_MULTIFACTOR_SECURTIY_LINK === true;

export const troweReportEnabled = () =>
  FEATURES.AAM_UI_T_ROWE_REPORT_ENABLED === true;

export const taxSummaryEnabled = () =>
  FEATURES.AAM_UI_TAX_SUMMARY_CARD === true;

export const grantViewAccessEnabled = () =>
  FEATURES.AAM_UI_GRANT_VIEW_ACCESS_PAGE === true;

export const gvaAddNewButton = () =>
  FEATURES.AAM_UI_GVA_ADD_NEW_BUTTON === true;

export const iraContributionCardEnabled = () =>
  FEATURES.AAM_UI_IRA_CONTRIBUTION_CARD === true;

export const financialPlanningLinkEnabled = () =>
  FEATURES.AAM_UI_FINANCIAL_PLANNING_LINK === true;

export const wsjEnabled = () => FEATURES.AAM_UI_WALL_STREET_JOURNAL === true;

export const customVideoEnabled = () =>
  FEATURES.AAM_UI_CUSTOM_VIDEO_ENABLED === true;

export const accountRegistrationEnabled = () =>
  FEATURES.AAM_UI_ACCOUNT_REGISTRATION === true;

export const alertsAndNotificationsEnabled = () =>
  FEATURES.AAM_UI_ALERTS_AND_NOTIFICATIONS === true;

export const GPCSubscriptionsEnabled = () =>
  FEATURES.AAM_UI_GLOBAL_PREFERENCES_SUBSCRIPTIONS_ENABLED === true;

export const isAdvicePerformancePageEnabled = () =>
  FEATURES.AAM_UI_RAS_PERFORMANCE_PAGE === true;

export const oldBenefitsEnabled = () => FEATURES.AAM_UI_OLD_BENEFITS === true;

export const rasWithdrawLinksEnabled = () =>
  FEATURES.AAM_UI_RAS_WITHDRAW_LINKS === true;

export const dashboardCTAButtonsEnabled = () =>
  FEATURES.AAM_UI_DASHBOARD_CTA_BUTTONS_ENABLED === true;

export const updatedSummitBenefitsEnabled = () =>
  FEATURES.AAM_UI_UPDATED_SUMMIT_BENEFITS_ENABLED === true;

export const marginJournalEnabled = () =>
  FEATURES.AAM_UI_MARGIN_JOURNAL_ENABLED === true;

export const isRMDDirectEnabled = () => FEATURES.AAM_UI_RMD_DIRECT === true;

export const updatedLifeEventsEnabled = () =>
  FEATURES.AAM_UI_UPDATED_LIFE_EVENTS_ENABLED === true;

export const documentAccountShellEnabled = () =>
  FEATURES.AAM_UI_DOCUMENT_ACCOUNT_SHELL_ENABLED === true;

export const cwvMarylandContributionTileEnabled = () =>
  FEATURES.AAM_UI_MD_MATCH_CWV_ENABLED === true;

export const beneficiaryLockDisabled = () =>
  FEATURES.AAM_UI_BENEFICIARY_LOCK_DISABLE === true;

export const non529OnlyLRNTaxesDashboardAccountsBenefits = () =>
  FEATURES.AAM_UI_NON_529_ONLY_LEGAL_REFERENCE_NUMBER_ENABLE === true;

export const IIComponentsFooterEnabled = () =>
  FEATURES.II_COMPONENTS_FOOTER_ENABLED === true;

export const owned529OnlyBrandingEnabled = () =>
  FEATURES.AAM_UI_OWNED_529_ONLY_BRANDING === true;

export const residentialAddressEnabled = () =>
  FEATURES.AAM_UI_RESIDENTIAL_ADDRESS_ENABLED === true;

export const rmdGaugeEnabled = () => FEATURES.AAM_UI_RMD_GAUGE_CARD === true;

export const shareClassConversionEnabled = () =>
  FEATURES.AAM_SHARE_CLASS_CONVERSION_ENABLED === true;

export const shareClassConversionTableEnabled = () =>
  FEATURES.AAM_SHARE_CLASS_CONVERSION_TABLE_ENABLED === true;

export const rothInheritedAccountsGVAEnabled = () =>
  FEATURES.AAM_UI_ROTH_INHERITED_ACCOUNTS_GVA_ENABLED === true;

export const paperlessPageEnabled = () =>
  FEATURES.AAM_UI_PAPERLESS_PAGE_ENABLED === true;

export const updatedBankingPageAccountFormsEnabled = () =>
  FEATURES.AAM_UI_BANKING_PAGE_UPDATE_ACCOUNT_FORMS === true;

export const nasuInprogressReturnJourneyTile = () =>
  FEATURES.NASU_INPROGRESS_RETURN_JOURNEY_TILE === true;

export const clientMissionsEnabled = () =>
  FEATURES.AAM_UI_CLIENT_MISSIONS_ENABLED === true;

export const beaconDatePickerEnabled = () =>
  FEATURES.AAM_UI_BEACON_DATE_SELECTOR_ENABLED === true;


export const accountsGridBeaconDatePickerEnabled = () =>
  FEATURES.AAM_UI_ACCOUNTS_GRID_BEACON_DATE_SELECTOR_ENABLED === true;

export const addLRNEnabled = () =>
  FEATURES.AAM_UI_LEGAL_REFERENCE_NUMBER_ENABLE === true;

export const addActivitySummaryTableErrorScreenEnabled = () =>
  FEATURES.AAM_UI_ACTIVITY_SUMMARY_ERROR_SCREEN_ENABLED === true;

export const addPortfolioGrowthTableErrorScreenEnabled = () =>
  FEATURES.AAM_UI_PORTFOLIO_GROWTH_CHART_ERROR_SCREEN_ENABLED === true;

export const loadingBarEnabled = () => FEATURES.AAM_UI_LOADING_BAR === true;

export const setDomLayoutEnabled = () =>
  FEATURES.AAM_UI_PRINT_DOM_LAYOUT_ENABLED === true;
export const brokerageFrameEnabled = () =>
  FEATURES.AAM_UI_BROKERAGE_I_FRAME_ENABLED === true;

export const activityPageBeaconDatePickerEnabled = () =>
  FEATURES.AAM_UI_ACTIVITY_PAGE_BEACON_DATE_SELECTOR_ENABLED === true;
export const educationPlanningCenterDisabled = () =>
  FEATURES.AAM_UI_EDUCATION_PLANNING_CENTER_DISABLED === true;

export const retailTracEnabled = () =>
  FEATURES.AAM_UI_RETAIL_TRAC_ENABLED === true;

export const statementPageNoTaxDocumentEnabled = () =>
  FEATURES.AAM_UI_STATEMENT_PAGE_NO_TAX_DOCUMENT_TEXT_UPDATE_ENABLED === true;

export const includeNewRetirementFundsForDivCap = () =>
  FEATURES.AAM_UI_DIVCAPGAINS_INCLUDE_NEW_RETIREMENT_FUNDS === true;

export const custodyStatementsEnabled = () =>
  FEATURES.AAM_UI_CUSTODY_STATEMENT_ENABLED === true;

export const rasPOAEnabled = () => FEATURES.AAM_UI_RAS_POA === true;

export const isTrustedContactsAccountNumberEnabled = () =>
  FEATURES.AAM_UI_TRUSTED_CONTACTS_ACCOUNT_NUMBER_ENABLED === true;

export const ak529DecomEnabled = () =>
  FEATURES.AAM_UI_AK_529_DECOM_ENABLED === true;

export const newDeleteBankEnabled = () =>
  FEATURES.AAM_UI_DELETE_BANK_NEW_API === true;

export const isBrokerageOrderStatusTablesEnabled = () =>
  FEATURES.AAM_UI_BROKERAGE_ORDER_STATUS_TABLES === true;

export const isManagePassKeyEnabled = () =>
  FEATURES.AAM_UI_MANAGE_PASSKEY_ENABLED === true;

export const addressOnFileEnabled = () =>
  FEATURES.AAM_UI_ADDRESS_ON_FILE_BUTTON_ENABLED === true;

export const gvaNewCopyEnabled = () =>
  FEATURES.AAM_UI_GVA_NEW_COPY_ENABLED === true;

export const clientPortalEnabled = () =>
  FEATURES.CLIENT_PORTAL_ENABLED === true;

export const redirectToClientPortalEnabled = () =>
  FEATURES.REDIRECT_TO_CLIENT_PORTAL_ENABLED === true;

export const isMoneyMarketCutoffEnabled = () =>
  FEATURES.AAM_UI_MONEY_MARKET_CUTOFF_ENABLED === true;

export const beneficiariesEnabled = () =>
  FEATURES.AAM_UI_BENEFICIARIES_V2 === true;

export const isBrokerageTradingEnabled = () =>
  FEATURES.AAM_UI_BROKERAGE_TRADING === true;

export const isPerformancePageLabelsEnabled = () =>
  FEATURES.AAM_UI_PERFORMANCE_PAGE_LABELS === true;

export const isBrkInterceptMsgEnabled = () =>
  FEATURES.AAM_UI_BROKERAGE_INTERCEPT_MESSAGE === true;

export const isBrokerageAccountViewMessageEnabled = () =>
  FEATURES.AAM_UI_BROKERAGE_ACCOUNT_DASHBOARD_MESSAGE === true;

export const isUpdatedNovemberBenchmarksEnabled = () =>
  FEATURES.AAM_UI_UPDATED_NOVEMBER_BENCHMARKS_ENABLED === true;

export const enableBeneBrokerageAdvantage = () =>
  FEATURES.AAM_UI_ENABLE_BRK_ADVANTAGE_BENE === true;

export const isBenesJointToTodEnabled = () =>
  FEATURES.AAM_UI_BENEFICIARIES_V2_JOINT_TO_TOD === true;

// Set AAM_UI_CONTACT_METHOD_ANNUAL_VERIFICATION to false will turn off CMM annual review
export const isContactMethodAnnualVerificationEnabled = () =>
  FEATURES.AAM_UI_CONTACT_METHOD_ANNUAL_VERIFICATION === true;

export const enableInheritedBeneDeceased = () =>
  FEATURES.AAM_UI_ENABLE_INHERITED_BENE_DECEASED === true;

export const frontendMonitoringEnabled = () =>
  FEATURES.AAM_UI_FRONTEND_MONITORING_ENABLED === true;

export const balanceDetailsEnabled = () =>
    FEATURES.AAM_UI_BALANCE_DETAILS_ENABLED === true;

export const intradayOnPageLoadEnabled = () =>
  FEATURES.AAM_UI_INTRADAY_PAGE_LOAD === true;

export default {
  activitySummaryCommentaryEnabled,
  alertsAndNotificationsEnabled,
  isAdvicePerformancePageEnabled,
  intradayRefreshEnabled
};
